/**
 * @generated SignedSource<<8cb7c7d6ccd9d22d9384e9d2f31b96ad>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SncProductDrawerFragment$data = {
  readonly id: string;
  readonly priceAmount: number;
  readonly product: {
    readonly brand: {
      readonly id: string;
      readonly name: string;
      readonly organization: {
        readonly id: string;
        readonly imprint: string | null | undefined;
        readonly name: string;
      };
    };
    readonly category: {
      readonly i18N: any;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly description: string | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly photo: {
      readonly id: string;
      readonly variant: string;
    };
  };
  readonly stock: number;
  readonly " $fragmentType": "SncProductDrawerFragment";
};
export type SncProductDrawerFragment$key = {
  readonly " $data"?: SncProductDrawerFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SncProductDrawerFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SncProductDrawerFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stock",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CloudflareImage",
          "kind": "LinkedField",
          "name": "photo",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "variant",
                  "value": "PUBLIC"
                }
              ],
              "kind": "ScalarField",
              "name": "variant",
              "storageKey": "variant(variant:\"PUBLIC\")"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Brand",
          "kind": "LinkedField",
          "name": "brand",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Organization",
              "kind": "LinkedField",
              "name": "organization",
              "plural": false,
              "selections": [
                (v0/*:: as any*/),
                (v1/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "imprint",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Category",
          "kind": "LinkedField",
          "name": "category",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "i18N",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SncProduct",
  "abstractKey": null
};
})();

(node as any).hash = "759b08b3408718f3493f1ea31ea19c6c";

export default node;
